import { render } from "./PTable.vue?vue&type=template&id=54a1ab04"
import script from "./PTable.vue?vue&type=script&lang=js"
export * from "./PTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__